import React from 'react';

import Icon from 'components/shared/Icon/Icon';
import Button from 'components/shared/Button/Button';
import Loader from 'components/shared/Loader/Loader';
import Typography from 'components/shared/Typography/Typography';

const LoadingWrapper = ({ children, isLoading, error, retry, id }) => {
  if (!!error) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center gap-2 p-6">
        <Icon icon="illustration-payment-failed" />
        <Typography variant="p" size="medium" weight="medium">
          Something went wrong
        </Typography>
        <Typography variant="p" color="neutral-600" size="small">
          Please try again.
        </Typography>
        <Button onClick={retry} text="Retry" size="small" icon="refresh-linear" iconColor="white" />
      </div>
    );
  }

  return (
    <div className="relative w-full" aria-busy={isLoading} id={id}>
      {isLoading && (
        <div
          role="status"
          aria-live="polite"
          aria-label="Loading"
          className="pointer-events-auto absolute inset-0 z-10 flex items-center justify-center rounded-md bg-white/50">
          <Loader color="primary" size={40} />
        </div>
      )}
      {children}
    </div>
  );
};

export default LoadingWrapper;
